<template>
    <fragment>
        <div :class="`datepicker ${wrapperClass}`">
            <CustomSelect
                :defaultOption="'Day' | translate"
                validateAs="day"
                :hasValue="computedDay ? computedDay : false"
                :required="true"
                :options="days"
                :label="'dob-day'"
                :handler="dobHandler"
                :disabledCheck="isDisabled"
            >
                <template slot-scope="{slotKey}">
                    <span>{{ twoDigits(slotKey) }}</span>&nbsp;
                </template>
            </CustomSelect>
            <CustomSelect
                :defaultOption="'Month' | translate"
                validateAs="month"
                :hasValue="computedMonth ? months[computedMonth.replace(/^0+/, '') - 1] : false"
                :required="true"
                :options="months"
                :label="'dob-month'"
                :handler="dobHandler"
                :shrinkContent="true"
                :disabledCheck="isDisabled"
            />
            <input
                :data-initial-value="computedYear"
                ref="dobYear"
                v-validate="'required|isYear'"
                :data-vv-as="'year' | translate"
                id="dob-year"
                type="number"
                class="form-control dob-year"
                min="1900"
                :max="yearMax"
                step="1"
                name="dob-year"
                required
                @keypress="preventNonNumeric"
                @input="handleYear"
                @change="dobHandler"
                :disabled="isDisabled"
                :placeholder="'Year' | translate"
                autocomplete="off"
            />
        </div>
        <InlineError
            :wrapperClass="wrapperClass + ' offset-md-3'"
            :errors="errors"
            :type="['dob-day', 'dob-month', 'dob-year']"
        />
    </fragment>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapState } from 'vuex';
import CustomSelect from '@C/CustomSelect';
import InlineError from '@C/Forms/InlineError';
import { twoDigits } from '@H/enrolment';
export default {
    inject: ['$validator'],
    name: 'DOBPicker',
    created() {
        let dob = this.user && this.user.date_of_birth
            ? this.user.date_of_birth.split('-')
            : '';

        this.innerDay = dob[2] || null;
        this.innerMonth = dob[1] || null;
        this.innerYear = dob[0] || '';
    },
    mounted() {
        this.$refs.dobYear.setAttribute(
            'value',
            this.$refs.dobYear.getAttribute('data-initial-value')
        );

        if (this.computedYear !== '') {
            this.dobHandler(this.$refs.dobYear);
        }
    },
    data() {
        return {
            innerDay: '',
            innerMonth: '',
            innerYear: ''
        };
    },
    props: {
        wrapperClass: {
            type: String,
            default: ''
        },
        user: {
            type: Object,
            required: false
        },
        days: {
            type: Number,
            required: true
        },
        months: {
            type: Array,
            required: true
        },
        day: {
            type: [String, Boolean],
            required: true
        },
        month: {
            type: [String, Boolean],
            required: true
        },
        year: {
            type: [String, Boolean],
            required: true
        },
        dobHandler: {
            type: Function,
            required: true
        },
        disabledCheck: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CustomSelect,
        InlineError
    },
    computed: {
        ...mapFields('Enrolment', ['dobYear']),
        ...mapState(['formSubmitting']),
        isDisabled() {
            return this.disabledCheck || this.$store.state.formSubmitting;
        },
        computedDay() {
            return this.day ? this.day : this.innerDay;
        },
        computedMonth() {
            return this.month ? this.month : this.innerMonth;
        },
        computedYear() {
            return this.year ? this.year : this.innerYear;
        },
        yearMax() {
            return (new Date()).getFullYear();
        }
    },
    methods: {
        twoDigits,
        preventNonNumeric(e) {
            if (e.which < 48 || e.which > 57) {
                e.preventDefault();
            }
        },
        handleYear(e) {
            if (e.target.value.length > 4) {
                e.preventDefault();
                e.target.value = e.target.value.slice(0, 4);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DOBPicker.vue